import { useEffect, useState } from 'react'
import { Stack, Typography, Box, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import FsStepper from '../../components/fs-etl/common/Stepper'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { changeCurrentStep } from '../../store/actions'
import FsDataUpload from '../../components/fs-etl/fs-external/DataUpload'
import FsDataSource from '../../components/fs-etl/fs-external/DataSource'
import FsDataPreparation from '../../components/fs-etl/fs-external/DataPreparation'
import FsAnalysisPreparation from '../../components/fs-etl/fs-external/AnalysisPreparation'
import { getIcon } from '../../components/common/Icons'
import FsFullPageLoader from '../../components/common/atoms/FullPageLoader'

const FsETLExternalView = () => {
  const { currentStep, latestEtlStatus } = useAppSelector((state) => state.currentEtl)
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const theme = useTheme()
  const isSuccess = latestEtlStatus && latestEtlStatus.status && latestEtlStatus.step === 1

  const ETL_EXTERNAL_STEPS = [
    t('data.source'),
    t('data.upload'),
    t('data.preparation'),
    t('data.analysis'),
  ]

  useEffect(() => {
    if (latestEtlStatus) {
      if (latestEtlStatus.status) {
        dispatch(changeCurrentStep(3))
      } else if (latestEtlStatus.step >= 5) dispatch(changeCurrentStep(2))
      else if (latestEtlStatus.step >= 3) dispatch(changeCurrentStep(1))
    }
  }, [latestEtlStatus])

  const handleButtonClickForth = () => {
    if (currentStep === ETL_EXTERNAL_STEPS.length) return
    dispatch(changeCurrentStep(currentStep + 1))
  }

  const handleButtonClickBack = () => {
    if (currentStep === ETL_EXTERNAL_STEPS.length - 1) return
    dispatch(changeCurrentStep(currentStep - 1))
  }

  const getCurrentView = () => {
    switch (true) {
      case currentStep === 0:
        return <FsDataSource goNext={handleButtonClickForth} />
      case currentStep === 1:
        return <FsDataUpload setIsLoading={setIsLoading} goBack={handleButtonClickBack} />
      case currentStep === 2:
        return <FsDataPreparation />
      case currentStep === 3:
        return <FsAnalysisPreparation />
      default:
        return null
    }
  }

  return (
    <Stack alignItems="flex-start" ml={2}>
      <Stack direction="row" alignItems="center" mb={2}>
        <Box mt={1}>{getIcon('etl')}</Box>
        <Typography variant="h1" ml={1} pr={2} mt={0.5}>
          {t('upload.data')}
        </Typography>
      </Stack>
      <Stack width="100%" direction="column" gap={2}>
        <FsStepper steps={ETL_EXTERNAL_STEPS} activeStep={currentStep} />
        <Typography variant="h2" mb={2}>
          {ETL_EXTERNAL_STEPS[currentStep]}
        </Typography>
      </Stack>
      <Box width="100%" height="calc(100vh - 263px)">
        {getCurrentView()}
      </Box>
      {isLoading && <FsFullPageLoader />}
    </Stack>
  )
}
export default FsETLExternalView
